module.exports = __webpack_public_path__ + "img/電気回路_2_3_3.cfcba03b.png";